import React from 'react';
import { DialogWrapper } from '@common/components/modal/dialog-wrapper';
import { withTranslation } from 'react-i18next';
import RoleFormContent from './role-form-content';

class RoleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmButtonDisabled: false,
    };
    this.handleDisabledChange = this.handleDisabledChange.bind(this);
  }

  handleDisabledChange(disabled) {
    this.setState({ confirmButtonDisabled: disabled });
  }

  handleConfirm = () => {
    // Trigger form submission via the form's submit button
    const formElement = document.getElementById('role-form');
    if (formElement && formElement instanceof HTMLFormElement) {
      formElement.requestSubmit();
    }
  };

  render() {
    const {
      show, children, onExited, onShow, level, role, t, submitting, invalid, ...rest
    } = this.props;

    const titleContent = level === 2 ?
      t('organisation:forms_role_organisation_title', {
        context: role && 'edit'
      }) :
      t('organisation:forms_role_network_title', {
        context: role && 'edit'
      });

    return (
      <DialogWrapper
        trigger={children}
        show={show}
        onHide={onExited}
        size="lg"
        onShow={onShow}
        title={titleContent}
        onConfirm={this.handleConfirm}
        confirmButtonText={t('organisation:forms_role_submit')}
        confirmButtonForm="role-form"
        confirmButtonType="submit"
        confirmButtonLoading={submitting}
        confirmButtonDisabled={this.state.confirmButtonDisabled}
        content={
          <RoleFormContent
            {...rest}
            level={level}
            role={role}
            onExited={onExited}
            onDisabledChange={this.handleDisabledChange}
          />
        }
      />
    );
  }
}

RoleForm.defaultProps = {
  show: false
};

export default withTranslation()(RoleForm);
